<template>
	<div class="author-profile">
		<div v-if="bankCards.length && !hasMainBankCard" class="vx-row">
			<div class="vx-col mb-5">
				<vx-card class="bg-danger">
					<span class="text-white" :style="{ fontWeight: 'bold' }">
						{{ $t("youDidNotChooseMainBankCard") }}
					</span>
				</vx-card>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vx-card>
					<div class="d-flex align-center">
						<div class="vx-col">
							<h1 class="m-0 mr-2">{{ $t("profile") }}</h1>
						</div>
					</div>

					<div class="info flex-col sm:flex-row mt-5">
						<div class="photo">
							<img
								style="width: 100%; height: 100%;"
								:src="$store.state.auth.user.photo"
								alt=""
							/>
						</div>

						<div class="data mt-10 sm:mt-0">
							<div class="tables vx-row">
								<table class="vx-col w-full lg:w-1/2">
									<tbody class="data__left-side">
										<tr>
											<td>{{ $t("personName") }}</td>
											<td>
												{{ model.first_name }}
												{{ model.last_name }}
											</td>
										</tr>

										<tr>
											<td>{{ $t("nickname") }}</td>
											<td>{{ model.username }}</td>
										</tr>

										<tr>
											<td>E-Mail</td>
											<td>{{ model.email }}</td>
										</tr>

										<tr>
											<td>{{ $t("emailForPayment") }}</td>
											<td>{{ model.email_payment }}</td>
										</tr>

										<tr v-if="bankCards.length">
											<td>{{ $t("bankCards") }}</td>
											<td>
												<div class="cards-list">
													<div
														v-for="item in bankCards"
														:key="item.id"
														:class="{
															selected:
																item.selected
														}"
														class="cards-list__item"
													>
														{{ item.number }}
													</div>
												</div>
											</td>
										</tr>

										<tr>
											<td>{{ $t("phone") }}</td>
											<td>{{ model.phone }}</td>
										</tr>
									</tbody>
								</table>

								<table
									class="vx-col w-full lg:w-1/2 mt-10 lg:mt-0"
								>
									<tbody>
										<tr>
											<td>{{ $t("birthDate") }}</td>
											<td>{{ birthDateOutput }}</td>
										</tr>
										<tr>
											<td>{{ $t("sex") }}</td>
											<td>
												{{
													$getDeep(
														model.gender,
														genders
													)
												}}
											</td>
										</tr>
										<tr>
											<td>{{ $t("country") }}</td>
											<td>
												{{
													$getDeep(
														model.country,
														countries
													)
												}}
											</td>
										</tr>
										<tr>
											<td>{{ $t("language") }}</td>
											<td>
												<div class="d-flex flex-wrap">
													{{ languagesOutput }}
												</div>
											</td>
										</tr>
										<tr>
											<td>{{ $t("subjects") }}</td>
											<td>
												<div class="d-flex flex-wrap">
													{{ subjectsOutput }}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<div class="about">
								<b>{{ $t("aboutYourself") }}</b>
								<p>{{ model.about }}</p>
							</div>
						</div>
					</div>

					<div class="buttons mt-8">
						<vs-button
							class="edit-btn"
							@click="$router.push('/profile/edit')"
						>
							{{ $t("edit") }}
						</vs-button>

						<vs-button
							v-if="isSolarStaff"
							:disabled="loading"
							@click="updateCardsList"
						>
							{{ $t("updateCardsList") }}
						</vs-button>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import notifier from "../../mixins/notifier";
import databaseManager from "../../mixins/databaseManager";

const TIMER_VALUE = 60 * 5;

export default {
	name: "Author",

	mixins: [databaseManager, notifier],

	data() {
		return {
			popupActive: false,
			val: "",
			description: "",
			countries: [],
			genders: [],
			languages: [],
			subjects: [],
			loading: false,
		};
	},

	computed: {
		model() {
			return this.$store.state.auth.user;
		},
		locale() {
			return this.$store.state.locale;
		},
		languagesOutput() {
			if(
        !this.model === undefined ||
        !this.model.languages ||
        !this.model.languages.length
      ) return

			return this.model.languages.map((el) => el[`name_${this.locale}`]).join(", ");
		},
		subjectsOutput() {
			if (!this.model === undefined || !this.model.subjects) return null;

			let output = [];
			for (let subject of this.model.subjects) {
				output.push(this.$getDeep(subject, this.subjects));
			}
			return output.join(", ");
		},
		birthDateOutput() {
			if (!this.model === undefined || !this.model.birth_date)
				return null;

			return this.model.birth_date
				.split("-")
				.reverse()
				.join(".");
		},

		hasMainBankCard() {
			const mainCard = this.bankCards.find(el => el.selected);
			return !!mainCard;
		},

		bankCards() {
			const cards =
				this.model && this.model.bank_cards
					? this.model.bank_cards
					: [];
			return cards;
		},

		isSolarStaff() {
			return this.model ? this.model.is_solar_staff : false;
		}
	},

	async mounted() {
		try {
			this.languages = (
				await this.$http.get("/settings/get-languages")
			).data.data;
			this.subjects = (
				await this.$http.get("/settings/get-subjects")
			).data.data;
			this.countries = (
				await this.$http.get("/settings/get-countries")
			).data.data;
			this.genders = (
				await this.$http.get("/settings/get-genders")
			).data.data;
		} catch (e) {}
	},

	methods: {
		acceptChangeManager() {},

		async updateCardsList() {
			try {
				this.loading = true;
				await this.dbRefreshBankCards();

        const res = (await this.$http.get('/author/profile')).data.data;
				await this.$store.dispatch("updateUserInfo", res);

				this.notifySuccess(this.$t("updatedSuccessfully"));
			} catch (err) {
				this.notifyError(err.message);
			} finally {
				this.loading = false;
			}
		},
	}
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.author-profile {
	.data {
		width: 100%;

		.cards-list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;
			grid-gap: 10px;

			&__item {
				white-space: nowrap;

				&.selected {
					border-radius: 4px;
					padding: 2px 4px;
					margin: 0 -2px;
					background: $success;
					color: #fff;
				}
			}
		}
	}

	.buttons {
		display: flex;
		flex-wrap: wrap;
		grid-gap: 20px;

		@media screen and (max-width: 756px) {
			grid-gap: 10px;
		}
	}

	.feature {
		span {
			color: $success;
		}

		.vx-card__body {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		strong {
			font-size: rem(18px);

			b {
				color: $danger;
			}
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
	}

	table {
		margin-bottom: 20px;
		padding-left: 15px;

		tr {
			td {
				padding-bottom: 7px;

				&:first-child {
					width: 250px;
					font-weight: 600;
				}
			}
		}
	}

	.info {
		display: flex;

		.tables {
			display: flex;
		}

		table {
			max-width: 550px;
			margin-bottom: 20px;
			padding-left: 15px;

			.data__left-side {
				tr {
					td {
						width: 60%;

						&:first-child {
							width: 40%;
							padding-right: 10px;
						}
					}
				}
			}

			tr {
				td {
					padding-bottom: 7px;
					width: 50%;
					vertical-align: top;

					&:first-child {
						max-width: 250px;
						font-weight: 600;
					}
				}
			}
		}

		.about {
			display: flex;
			margin-left: 5px;

			b {
				flex-shrink: 0;
				max-width: 258px;
				width: 25%;
			}

			@media screen and (max-width: 992px) {
				b {
					width: 50%;
				}
			}
		}
	}

	.photo {
		width: 200px;
		height: 200px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 15px;
		margin-left: 0;
		flex-shrink: 0;

		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	.edit-btn {
		width: 100%;
		max-width: 200px;
	}
}
</style>
